import { render, staticRenderFns } from "./PartnerHierarchy.vue?vue&type=template&id=273a2a42&scoped=true"
import script from "./PartnerHierarchy.vue?vue&type=script&lang=ts"
export * from "./PartnerHierarchy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a2a42",
  null
  
)

export default component.exports